import { RootDispatch } from '../store';
import { registerNewLDUserKey } from '../services/FeatureStore';

export interface OrganizationState {
  id: string;
  name: string;
  allowPhoto: boolean;
  allowAttachment: boolean;
  logo: string;
  phone: string;
}

const initialState: OrganizationState = {
  id: '',
  name: '',
  allowPhoto: true,
  allowAttachment: true,
  logo: '',
  phone: '',
};

export const organization = {
  effects: (dispatch: RootDispatch) => ({
    setOrganization(organization: any) {
      registerNewLDUserKey(organization.id);
      dispatch.organization.update(organization);
    },
  }),
  reducers: {
    update: (state: OrganizationState, organizationData: object): OrganizationState =>
      Object.assign({}, state, organizationData),
  },
  state: initialState,
};
